/*global $:false */

import {sprintf} from "sprintf-js";
import tmpl_dialog_title from '../templates/recordm-importer-stats-dialog-title.dot'
import tmpl_finished_msg from "../templates/recordm-importer-stats-dialog-finished-msg.dot";
import tmpl_import_line_error from "../templates/recordm-importer-line-error.dot";

const RecordmImporterStatsV = function(core, callbacks) {
    let _$totalProcessed,
        _$totalErrors,
        _$totalSuccess,
        _$totalIgnored,
        _$errorsContainer,
        _$errorsList,
        _$errorMsgContainer,
        _$abortBtn,
        _$timerContainer,
        _jTimer;

    const _stopTimer = function() {
        if(_jTimer) _jTimer.stop();
    };

    const _stop = function() {
        _stopTimer();

        _updateProgress(0,0,0);
        _removeErrors();
        _removeStatsLoadingErrorMsg();
    };

    const _removeErrors = function() {
        if(_$errorsContainer) _$errorsContainer.addClass("hidden");

        if(_$errorsList)_$errorsList.empty();
    };

    const _showErrors = function(errors) {
        if(errors.length > 0){
            _removeErrors();
            if(_$errorsContainer) _$errorsContainer.removeClass("hidden");

            errors.forEach(function(row){
                const errorDesc = sprintf(
                    core.translateString("recordm-importer-stats-dialog", "errors." + row.result),
                    row.rowNum,
                    row.msg
                );

                _$errorsList.prepend($(tmpl_import_line_error({result:row.result, errorDesc:errorDesc})));
            });

            _$errorsList.effect("highlight");
        }
    };

    const _updateProgress = function(numSuccesses, numErrors, numDiscarded) {
        if(_$totalProcessed){
            _$totalProcessed.text(numSuccesses+numErrors+numDiscarded);
            _$totalSuccess.text(numSuccesses);
            _$totalErrors.text(numErrors);
            _$totalIgnored.text(numDiscarded);
        }
    };

    const _removeStatsLoadingErrorMsg = function() {
        if( _$errorMsgContainer){
            _$errorMsgContainer.html("");
            _$errorMsgContainer.addClass("hidden");
        }
    };

    return {
        start: function($container, fileName) {
            if(!_jTimer){
                const $timer = $(".js-timer", $container);

                _$totalProcessed = $(".js-num-processed", $container);
                _$totalErrors = $(".js-num-errors", $container);
                _$totalSuccess = $(".js-num-success", $container);
                _$totalIgnored = $(".js-num-ignored", $container);
                _$errorsContainer = $('.js-errors-container', $container);
                _$errorsList = $('.js-import-errors', $container);
                _$errorMsgContainer = $('.js-error-msg-container', $container);
                _$timerContainer = $(".js-timer-container", $container);
                _$abortBtn = $(".js-abort", $container);

                _$abortBtn.on("click", () => {
                    _$abortBtn.addClass('disabled');
                    callbacks.abort();
                });

                _jTimer = $timer.timer({
                    display: true,
                    resetOnStart: true,
                    jobs: [
                        {
                            frequency: callbacks.getLoadStatsJobFrequency, //Seconds
                            action: callbacks.loadImportStats
                        }
                    ]
                });

                $(".js-import-progress", $container).removeClass("hidden");
                $(".js-modal-title", $container).html($(tmpl_dialog_title({fileName:fileName})));

                core.translate('recordm-importer-stats-dialog', $container);
            }

            _removeErrors();
            _jTimer.start();
        },
        stop: _stop,
        enableAbort: function(){
            _$abortBtn.removeClass("hidden");
        },
        updateProgress: _updateProgress,
        showErrors: _showErrors,
        showStatsLoadingError: function(errorStatus, errorStatusText){
            _$errorMsgContainer.html(sprintf(core.translateString("recordm-importer-stats-dialog", "errors.loading-stats"),
                errorStatus, errorStatusText));

            _$errorMsgContainer.removeClass("hidden");
            _$errorMsgContainer.effect("highlight");
        },
        showImportFinished: function(){
            if(_$timerContainer.children(".js-finished-label").length === 0){
                const $finishedMsg = tmpl_finished_msg();

                core.translate('recordm-importer-stats-dialog', $finishedMsg);

                _$timerContainer.prepend($finishedMsg);
            }
        },
        removeStatsLoadingError: _removeStatsLoadingErrorMsg,
        startTimer: function (){
            if(_jTimer){
                _jTimer.start();
            }
        },
        stopTimer: _stopTimer,
        timerRunning: function (){
            return _jTimer && _jTimer.isRunning();
        },
        updateTimer: function (elapsedTime){
            if(_jTimer){
                _jTimer.updateTime(elapsedTime);
            }
        }
    };
};

export default RecordmImporterStatsV;
